module.exports = __webpack_public_path__ + "img/win_bottom.e09a5734.png";